const {
  getPanel,
  addPanel,
  putpanel,
  getsearchresexp,
  getsearchresskl,
  addsearchresskl,
  addsearchresexp,
} = require("../../utils/apiFunctions");

const { clearpaneldata } = require("../../controllers/Panelist/helpers");

// TO SEARCH FOR AREA OF EXPERTISE IN DROPDOWN
const searchExp = async (vueObj) => {
  vueObj.spinnerStatus = true;
  try {
    const res = await getsearchresexp(vueObj.searchexp);
    if (res.status == 200) {
      vueObj.searchexpres = res.data.data;
      vueObj.spinnerStatus = false;
    }
  } catch (error) {
    throw new Error(`Failed! status: ${error.status}`);
  }
};

// TO SEARCH FOR SKILLS IN DROPDOWN
const searchSkl = async (vueObj) => {
  vueObj.spinnerStatus = true;
  try {
    const res = await getsearchresskl(vueObj.searchskl);
    if (res.status == 200) {
      vueObj.searchsklres = res.data.data;
      vueObj.spinnerStatus = false;
    }
  } catch (error) {
    throw new Error(`Failed! status: ${error.status}`);
  }
};

// TO GET DATA OF PARTICULAR PANELIST ON CLICK OF EDIT
const getPanelist = async (vueObj) => {
  try {
    let type = 2;
    const response = await getPanel(type, vueObj.panelistdata.panelID);
    vueObj.panel = await response.data.data;
    for (const expertise of vueObj.panel.areaOfExpertise) {
      vueObj.aoeoptiontags.push(expertise.name);
    }
    for (const skill of vueObj.panel.skills) {
      vueObj.skilloptionstag.push(skill.name);
    }
  } catch (error) {
    throw new Error(`get panelist Failed! status: ${error.status}`);
  }
};

const handlePanelData = async (vueObj, from, paneldata, hideSuccess) => {
  vueObj.LoaderStatus = true;
  vueObj.$emit("paneladd");

  try {
    const [responseexp, responseskl] = await Promise.all([
      addsearchresexp(vueObj.aoetags),
      addsearchresskl(vueObj.skillstags),
    ]);

    if (responseexp.status !== 200 || responseskl.status !== 200) {
      vueObj.errorToast(responseexp.response.data.data.Data);
      throw new Error(`Failed! Status:${responseexp.status}`);
    }

    let res;
    if (from === "fromAdd") {
      res = await addPanel(paneldata);
    } else {
      res = await putpanel(paneldata);
    }

    if (!hideSuccess) {
      vueObj.LoaderStatus = false;
    }

    if (res.status === 200) {
      if (from === "fromAdd" && !hideSuccess) {
        vueObj.$emit("onAddPanelist");
        vueObj.$nextTick(() => {
          vueObj.successModal("Panelist added successfully!");
        });
      } else if (!hideSuccess) {
        vueObj.$emit("onEditPanelist");
        vueObj.$nextTick(() => {
          vueObj.successModal("Panelist updated successfully");
        });
      }
      if (hideSuccess) {
        vueObj.panelFailure = false;
      }
      clearpaneldata(vueObj);
    } else if (res.status === 409) {
      const errorMessage = res.data.data.Detail;
      vueObj.errorModal(errorMessage);
      if (hideSuccess) {
        vueObj.panelFailure = true;
      } else {
        vueObj.$emit("failure");
      }
    } else {
      if (hideSuccess) {
        vueObj.panelFailure = true;
      } else {
        vueObj.$emit("failure");
      }
      vueObj.errorModal("Something went wrong!");
    }
  } catch (error) {
    vueObj.LoaderStatus = false;
    console.error(error);
    if (hideSuccess) {
      vueObj.panelFailure = true;
    }
  }
};

// TO ADD OR EDIT PANELIST DETAILS
const addUpdatePanel = async (vueObj, from) => {
  vueObj.LoaderStatus = true;
  vueObj.$v.$touch();

  if (vueObj.$v.$error) {
    vueObj.LoaderStatus = false;
    vueObj.errorModal("Please enter all the details");
    return;
  }

  if (!vueObj.$v.$invalid && vueObj.phoneValid) {
    vueObj.aoetags.expertise = vueObj.aoeoptiontags;
    vueObj.skillstags.skill = vueObj.skilloptionstag;

    const aoegrid = vueObj.aoeoptiontags.map((tag) => ({
      name: tag,
      code: tag,
    }));
    const skillgrid = vueObj.skilloptionstag.map((tag) => ({
      name: tag,
      code: tag,
    }));

    const paneldata = {
      name: vueObj.panel.name,
      phoneNumber: vueObj.panel.phoneNumber,
      email: vueObj.panel.email,
      skills: skillgrid,
      areaOfExpertise: aoegrid,
      active: true,
    };

    if (from === "fromEdit") {
      paneldata.panelID = vueObj.panel.panelID;
    }
    if (from === "fromAdd") {
      paneldata.force = true;
    }

    await handlePanelData(vueObj, from, paneldata);
  }
};

module.exports = {
  searchExp,
  searchSkl,
  getPanelist,
  addUpdatePanel,
  handlePanelData,
};
